__turbopack_context__.v({
  "card": "Card-module__Ev3C4G__card",
});
